/* LINGS: razkritje elementov ob pomiku (brez JS ostane vse vidno) */
(function () {
  var els = document.querySelectorAll('.lg-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  els.forEach(function (e) { io.observe(e); });
})();

/* LINGS: pripeta izjava. Ob pomiku razkriva točke na nedrčku, ena za drugo. */
(function () {
  var sections = document.querySelectorAll('[data-lg-scrolly]');
  if (!sections.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  sections.forEach(function (sec) {
    var hs = sec.querySelectorAll('.lg-hs');
    var hl = sec.querySelectorAll('.lg-hl');
    var dots = sec.querySelectorAll('.lg-scrolly__dot');
    var cap = sec.querySelector('.lg-scrolly__caption');
    var n = hs.length;
    if (!n) return;
    var titles = [], texts = [];
    hl.forEach(function (el) {
      var i = +el.getAttribute('data-index');
      titles[i] = el.querySelector('b') ? el.querySelector('b').textContent : '';
      texts[i] = el.querySelector('span') ? el.querySelector('span').textContent : '';
    });
    function apply(k) {
      hs.forEach(function (el) { var i = +el.getAttribute('data-index'); el.classList.toggle('is-on', i < k); el.classList.toggle('is-current', i === k - 1); });
      hl.forEach(function (el) { var i = +el.getAttribute('data-index'); el.classList.toggle('is-on', i < k); el.classList.toggle('is-current', i === k - 1); });
      dots.forEach(function (el, i) { el.classList.toggle('is-on', i < k); el.classList.toggle('is-current', i === k - 1); });
      if (cap) {
        if (k > 0) { cap.innerHTML = ''; var b = document.createElement('b'); b.textContent = titles[k - 1]; cap.appendChild(b); cap.appendChild(document.createTextNode(texts[k - 1])); }
        else { cap.textContent = ''; }
      }
    }
    if (reduce) { sec.classList.add('is-static'); apply(n); return; }
    sec.classList.add('lg-scrolly--ready');
    var last = -1, ticking = false;
    function update() {
      ticking = false;
      var r = sec.getBoundingClientRect();
      var total = sec.offsetHeight - window.innerHeight;
      var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 1;
      var k = p < 0.05 ? 0 : Math.min(n, Math.floor((p - 0.05) / (0.93 / n)) + 1);
      if (k !== last) { last = k; apply(k); }
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        var total = sec.offsetHeight - window.innerHeight;
        var top = sec.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: top + total * (0.05 + (i + 0.5) * (0.93 / n)), behavior: 'smooth' });
      });
    });
    update();
  });
})();

/* LINGS: v popupu aplikacije Ecomsend prikaži logotip brez okvirja (isti kot v glavi). */
(function () {
  var url = window.lgLogoUrl;
  if (!url) return;
  function swap(root) {
    var imgs = (root && root.querySelectorAll) ? root.querySelectorAll('[class*="ecomsend__Modal__LogoImg"]') : [];
    imgs.forEach(function (img) {
      if (img.getAttribute('data-lg-logo') === '1') return;
      img.setAttribute('data-lg-logo', '1');
      img.removeAttribute('srcset');
      img.src = url;
      img.alt = 'Lings Lingerie';
    });
  }
  var mo = new MutationObserver(function (list) {
    list.forEach(function (m) {
      if (m.type === 'childList') { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) { swap(n.matches && n.matches('[class*="ecomsend__Modal__LogoImg"]') ? n.parentNode : n); } }); }
      else if (m.type === 'attributes' && m.target.matches && m.target.matches('[class*="ecomsend__Modal__LogoImg"]') && m.attributeName === 'src' && m.target.src !== url) {
        m.target.setAttribute('data-lg-logo', '0'); swap(m.target.parentNode);
      }
    });
  });
  mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
  swap(document);
})();

/* LINGS: uvodni video. Predvaja samo prvih N sekund (data-end) v zanki, se ustavi zunaj vidnega polja in ob zmanjšanem gibanju. */
(function () {
  var videos = document.querySelectorAll('[data-lg-hero-video]');
  if (!videos.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  videos.forEach(function (v) {
    var end = parseFloat(v.getAttribute('data-end')) || 11;
    var btn = v.parentNode.querySelector('[data-lg-video-toggle]');
    var userPaused = reduce;
    var raf = null;
    function setBtn() {
      if (!btn) return;
      btn.setAttribute('aria-pressed', v.paused ? 'true' : 'false');
      var label = v.paused ? btn.getAttribute('data-play-label') : btn.getAttribute('data-pause-label');
      if (label) btn.setAttribute('aria-label', label);
    }
    function loop() {
      if (v.currentTime >= end) { v.currentTime = 0; }
      raf = window.requestAnimationFrame(loop);
    }
    function start() { if (raf === null) raf = window.requestAnimationFrame(loop); }
    function stop() { if (raf !== null) { window.cancelAnimationFrame(raf); raf = null; } }
    v.addEventListener('play', function () { start(); setBtn(); });
    v.addEventListener('pause', function () { stop(); setBtn(); });
    v.addEventListener('timeupdate', function () { if (v.currentTime >= end) v.currentTime = 0; });
    if (btn) {
      btn.addEventListener('click', function () {
        if (v.paused) { userPaused = false; v.play().catch(function () {}); } else { userPaused = true; v.pause(); }
      });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { if (!userPaused && v.paused) v.play().catch(function () {}); }
          else if (!v.paused) { v.pause(); }
        });
      }, { threshold: 0.25 }).observe(v);
    }
    if (reduce) { v.pause(); v.removeAttribute('autoplay'); }
    setBtn();
  });
})();
/* LINGS: domač popup "Prvi nakup" (10 % popust, brez zunanje aplikacije).
   Prikaz: ko obiskovalec podrsa 28 % strani, največ 2x na dan; ne naročnikom (to preveri Liquid).
   Če stranka popup zapre brez prijave, se ob strani prikaže stalen zavihek za ponoven priklic. */
(function () {
  var popup = document.getElementById('lg-popup');
  var tab = document.getElementById('lg-popup-tab');
  if (!popup) return;

  var STORE_KEY = 'lg_popup_shown';
  var SUBSCRIBED_KEY = 'lg_popup_subscribed';
  var TAB_KEY = 'lg_popup_tab_visible';
  var THRESHOLD = 0.28;
  var MAX_PER_DAY = 2;

  function today() { return new Date().toISOString().slice(0, 10); }

  function getShown() {
    try {
      var raw = JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
      if (raw && raw.date === today()) return raw;
    } catch (e) {}
    return { date: today(), count: 0 };
  }

  function bumpShown() {
    try { localStorage.setItem(STORE_KEY, JSON.stringify({ date: today(), count: getShown().count + 1 })); } catch (e) {}
  }

  function isSubscribed() {
    try { return localStorage.getItem(SUBSCRIBED_KEY) === '1'; } catch (e) { return false; }
  }

  function setSubscribed() {
    try { localStorage.setItem(SUBSCRIBED_KEY, '1'); } catch (e) {}
  }

  function showTab() {
    if (!tab || isSubscribed()) return;
    tab.hidden = false;
    try { localStorage.setItem(TAB_KEY, '1'); } catch (e) {}
  }

  function hideTab() {
    if (!tab) return;
    tab.hidden = true;
  }

  if (isSubscribed()) { hideTab(); return; }

  var lastFocused = null;
  var openedOnce = false;

  function openPopup() {
    hideTab();
    openedOnce = true;
    bumpShown();
    lastFocused = document.activeElement;
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      popup.classList.add('is-open');
      var input = popup.querySelector('.lg-popup__input');
      if (input) input.focus({ preventScroll: true });
    });
    document.removeEventListener('scroll', onScroll);
  }

  function closePopup(subscribed) {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    setTimeout(function () { popup.hidden = true; }, 320);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
    if (!subscribed) showTab();
  }

  popup.querySelectorAll('[data-lg-popup-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { closePopup(false); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup(false);
  });

  if (tab) {
    tab.addEventListener('click', openPopup);
    var tabWasVisible = false;
    try { tabWasVisible = localStorage.getItem(TAB_KEY) === '1'; } catch (e) {}
    if (tabWasVisible) showTab();
  }

  var ticking = false;
  function checkScroll() {
    ticking = false;
    if (openedOnce) return;
    var doc = document.documentElement;
    var max = doc.scrollHeight - doc.clientHeight;
    var pct = max > 0 ? (window.scrollY || doc.scrollTop) / max : 1;
    if (pct >= THRESHOLD) openPopup();
  }
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(checkScroll); }
  }
  if (getShown().count < MAX_PER_DAY) {
    window.addEventListener('scroll', onScroll, { passive: true });
    checkScroll();
  }

  var form = popup.querySelector('.lg-popup__form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('.lg-popup__submit');
      if (submitBtn) submitBtn.disabled = true;
      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
      })
        .catch(function () {})
        .finally(function () {
          setSubscribed();
          try { localStorage.removeItem(TAB_KEY); } catch (e) {}
          var body = popup.querySelector('[data-lg-popup-body]');
          var success = popup.querySelector('[data-lg-popup-success]');
          if (body) body.hidden = true;
          if (success) success.hidden = false;
          setTimeout(function () { closePopup(true); }, 3500);
        });
    });
  }
})();

/* LINGS: zapomni si, da je stranka že potrdila splošne pogoje (lastno polje, brez aplikacije),
   da ji jih ni treba znova obkljukati ob vsakem odpiranju košarice/obvestila. */
(function () {
  var KEY = 'lg_terms_agreed';
  var SELECTOR = '.lg-terms-checkbox';
  function isAgreed() { try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function setAgreed() { try { localStorage.setItem(KEY, '1'); } catch (e) {} }

  function applyTo(cb) {
    if (!cb || cb.checked || !isAgreed()) return;
    cb.checked = true;
    cb.dispatchEvent(new Event('change', { bubbles: true }));
    cb.dispatchEvent(new Event('input', { bubbles: true }));
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches(SELECTOR) && e.target.checked) {
      setAgreed();
    }
  });

  document.querySelectorAll(SELECTOR).forEach(applyTo);

  if ('MutationObserver' in window) {
    var obs = new MutationObserver(function () {
      document.querySelectorAll(SELECTOR).forEach(applyTo);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }
})();

/* LINGS: koda za popust v košarici (native, brez aplikacije).
   Uporabi Shopify-jevo javno /discount/{koda} pot, ki kodo shrani na
   checkout sejo in preusmeri nazaj na trenutno stran. */
(function () {
  function applyDiscount(input) {
    if (!input) return;
    var code = (input.value || '').trim();
    if (!code) return;
    var redirect = window.location.pathname + window.location.search;
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#lg-cart-discount-apply, .lg-cart-discount__apply');
    if (!btn) return;
    var wrap = btn.closest('.lg-cart-discount');
    var input = wrap ? wrap.querySelector('.lg-cart-discount__input') : document.getElementById('lg-cart-discount-code');
    applyDiscount(input);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (!e.target.matches || !e.target.matches('.lg-cart-discount__input')) return;
    e.preventDefault();
    applyDiscount(e.target);
  });
})();

/* LINGS: cross-sell (nadomešča Essential Upsell). Pokaže ustrezno ponudbo glede na izdelek (stran izdelka)
   ali vsebino košarice, skrije že dodane izdelke in se osveži ob vsaki spremembi košarice.
   Dodajanje v košarico opravi Shopifyjev <product-form> (AJAX). Podatki: snippets/lings-crosssell.liquid */
(function () {
  var roots = document.querySelectorAll('[data-lg-xsell]');
  if (!roots.length) return;

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .catch(function () { return { items: [] }; });
  }

  function parseTrigger(str) {
    var out = { all: false, map: {} };
    if (!str || str === 'all') { out.all = true; return out; }
    str.split(';').forEach(function (p) {
      var a = p.split(':');
      if (a[0]) out.map[a[0].trim()] = (a[1] || '').trim();
    });
    return out;
  }

  function refresh(root, cart) {
    var ctx = root.getAttribute('data-context');
    var pid = root.getAttribute('data-product-id') || '';
    var ids = (cart.items || []).map(function (i) { return String(i.product_id); });
    var any = false;

    root.querySelectorAll('[data-lg-xsell-slot]').forEach(function (slot) {
      var trig = parseTrigger(slot.getAttribute('data-trigger'));
      var source = null;
      if (ctx === 'product') {
        if (pid && (trig.all || Object.prototype.hasOwnProperty.call(trig.map, pid))) source = pid;
      } else {
        for (var i = 0; i < ids.length; i++) {
          if (trig.all || Object.prototype.hasOwnProperty.call(trig.map, ids[i])) { source = ids[i]; break; }
        }
      }
      var color = source && trig.map[source] ? trig.map[source] : '';
      var cards = [].slice.call(slot.querySelectorAll('.lg-xsell__card'));
      var eligible = cards.filter(function (c) {
        var id = c.getAttribute('data-product-id');
        return ids.indexOf(id) === -1 && id !== pid;
      });
      var chosen = null;
      if (source && eligible.length) {
        if (slot.getAttribute('data-match-color') === '1') {
          for (var j = 0; j < eligible.length; j++) {
            if (color && eligible[j].getAttribute('data-color') === color) { chosen = eligible[j]; break; }
          }
        } else {
          chosen = eligible[0];
        }
      }
      cards.forEach(function (c) { c.hidden = c !== chosen; });
      slot.hidden = !chosen;
      if (chosen) any = true;
    });
    root.hidden = !any;
  }

  function refreshAll() {
    fetchCart().then(function (cart) { roots.forEach(function (r) { refresh(r, cart); }); });
  }

  refreshAll();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refreshAll(); });
  }

  /* izbira različice: posodobi ceno v kartici */
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.classList || !sel.classList.contains('lg-xsell__select')) return;
    var opt = sel.options[sel.selectedIndex];
    var card = sel.closest('.lg-xsell__card');
    if (!opt || !card) return;
    var idInput = card && card.querySelector('input[name="id"]');
    if (idInput) idInput.value = opt.value;
    var price = card.querySelector('[data-lg-xsell-price]');
    var compare = card.querySelector('[data-lg-xsell-compare]');
    var cmp = opt.getAttribute('data-compare') || '';
    if (price) { price.textContent = opt.getAttribute('data-price') || ''; price.classList.toggle('is-sale', !!cmp); }
    if (compare) { compare.textContent = cmp; compare.hidden = !cmp; }
  });
})();
